/**
 * Parse a WebVTTConfigurationBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed WebVttConfigurationBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function vttC(view) {
    return {
        config: view.readUtf8(),
    };
}
;
//# sourceMappingURL=vttC.js.map